import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import 'reset-css/reset.css';
import '../color/color';
import '../color/color-hsl';
import '../grid/grid';
import '../typography/typography';
import css from './form-input.css';

const FormInput = forwardRef(
  (
    {
      ariaLabel,
      disabled,
      error,
      id,
      inverse,
      max,
      maxLength,
      min,
      name,
      onBlur,
      onChange,
      placeholder,
      slim,
      step,
      type,
      value,
      ...otherProps
    },
    ref,
  ) => (
    <input
      aria-label={ariaLabel}
      className={classnames(css['ds-form-input'], {
        [css['ds-form-input--invalid']]: !!error,
        [css['ds-form-input--slim']]: slim,
        [css['ds-form-input--inverse']]: inverse,
        [css['ds-number-input']]: type === 'number',
        [css['ds-date-input']]: type === 'date',
      })}
      disabled={disabled}
      id={id}
      max={max}
      maxLength={maxLength}
      min={min}
      name={name}
      onBlur={onBlur}
      onChange={onChange}
      placeholder={placeholder}
      ref={ref}
      step={step}
      type={type}
      value={value}
      {...otherProps}
    />
  ),
);

FormInput.displayName = 'FormInput';

FormInput.defaultProps = {
  ariaLabel: null,
  disabled: false,
  error: '',
  id: '',
  inverse: null,
  name: '',
  max: null,
  maxLength: null,
  min: null,
  onBlur: null,
  onChange: null,
  placeholder: null,
  slim: null,
  step: null,
  type: 'text',
  value: '',
};

FormInput.propTypes = {
  ariaLabel: PropTypes.string,
  disabled: PropTypes.bool,
  error: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  id: PropTypes.string,
  inverse: PropTypes.bool,
  max: PropTypes.string,
  maxLength: PropTypes.number,
  min: PropTypes.string,
  name: PropTypes.string,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
  slim: PropTypes.bool,
  step: PropTypes.string,
  type: PropTypes.oneOf(['text', 'number', 'date', 'email', 'password']),
  value: PropTypes.string,
};

export default FormInput;
